import { render, staticRenderFns } from "./SelectResources.vue?vue&type=template&id=9c432922"
import script from "./SelectResources.vue?vue&type=script&lang=ts"
export * from "./SelectResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports